/**
 * Creates a object for every .Users DOM element.
 */
common.View.create('static tenants::admin.users.createEdit.Tenants', {

    triggerFields()
    {
        // Trigger tenants field on change
        $('[type="hidden"][name$="[has_unlimited_sub_access]"][value="partial"]')
            .parent()
            .find('[type="checkbox"]')
                .prop('indeterminate', true)
                .end();
    },

    getCurrentTargetName(name)
    {
        return name.replace('[value]', '');
    },

    /**
     * Check or clear the whole environments tree in one go. Only checkboxes the
     * admin may change are touched; branch nodes are recomputed afterwards so a
     * disabled parent ends up 'partial' (its children are saved individually)
     * instead of 'false' (which would drop them on save).
     */
    setAllTenants(event, state)
    {
        let $fieldset = $(event.target).closest('.userContexts').find('fieldset').first();

        $fieldset.find('input[type="checkbox"]').not('[disabled]').each(function () {
            $(this)
                .prop('checked', state)
                .prop('indeterminate', false)
                .siblings('input[name$="[has_unlimited_sub_access]"]')
                    .val(state ? 'true' : 'false');
        });

        // Bottom-up so deeper branches settle before their parents are derived.
        $($fieldset.find('li').has('ul').get().reverse()).each(function () {
            let $checkbox = $(this).find('> div input[type="checkbox"]'),
                $hidden = $(this).find('> div input[type="hidden"][name$="[has_unlimited_sub_access]"]'),
                $children = $(this).children('ul').find('input[type="checkbox"]'),
                checkedCount = $children.filter(':checked').length,
                activeCount = $children.filter(function () {
                    return this.checked || this.indeterminate;
                }).length;

            if (!activeCount) {
                $checkbox.prop('checked', false).prop('indeterminate', false);
                $hidden.val('false');
            } else if (checkedCount === $children.length && !$checkbox.attr('disabled')) {
                $checkbox.prop('checked', true).prop('indeterminate', false);
                $hidden.val('true');
            } else {
                $checkbox.prop('checked', false).prop('indeterminate', true);
                $hidden.val('partial');
            }
        });
    },

	selectToggle(event)
	{
        // Get select boxes
        let checkboxes = document.querySelectorAll('[type="checkbox"][name^="' + this.getCurrentTargetName(event.target.name) + '"]'),
            hiddenInput = document.querySelector('[type="hidden"][name="' + this.getCurrentTargetName(event.target.name) + '[has_unlimited_sub_access]"]'),
            hiddenInputs = document.querySelectorAll('[type="hidden"][name^="' + this.getCurrentTargetName(event.target.name) + '"][name$="[has_unlimited_sub_access]"]');

        // Target is checked? Then we set it to indeterminate
        if( checkboxes.length > 1 ) {
            // Toggle indeterminate action; if checked box is clicked this will stop further functionality
            if( this.toggleIndeterminate(event, hiddenInput, checkboxes) ) {
                return;
            }
        }

        // Set hidden field value based on the current check
        $(hiddenInputs).val($(event.target).prop('checked'));

        // Loop all parents to see if the parent needs to be checked or set indeterminate
        this.toggleParentCheckboxes(event);
	},

    toggleIndeterminate(event, hiddenInput, checkboxes)
    {
        // Check based on hidden input value since this is more actual that the checkbox value
        switch (hiddenInput.value) {
            case 'true':
                // Turn on indeterminate
                $(event.target).prop('indeterminate', true);

                // Set value for indeterminate
                $(hiddenInput).val('partial');

                // Also make parent partial
                this.toggleParentCheckboxes(event);

                return true;
            case 'partial':
                // Turn off checkbox
                $(checkboxes)
                    .prop('indeterminate', false)
                    .prop('checked', false);

                break;
            case 'false':
                // Turn on checkboxes
                $(checkboxes).prop('indeterminate', false)
                    .prop('checked', $(event.target).prop('checked'));

                break;
        }
    },

    toggleParentCheckboxes(event)
    {
        // Loop all parents to check if inputs need to be checked / set indeterminate / unchecked.
        $(event.target).parents('ul').each(function(key, val) {
            // Get all inputs and checked inputs (of parent)
            let inputsLength = $(val).find('input[type="checkbox"]').length,
                checkedInputsLength = $(val).find('input[type="checkbox"]:checked').length;

            // Set indeterminate on parent? We check all inputs based on the current loop
            if( !checkedInputsLength ) {
                $(val).parent()

                    // Set indeterminate false since inputs are not checked
                    .find('> div input[type="checkbox"]')
                        .prop('checked', false)
                        .prop('indeterminate', false)
                        .end()

                    // Set hidden input value false since inputs are not checked
                    .find('> div input[type="hidden"][name*="access"]')
                        .val(false)
                        .end();
            } else {
                $(val).parent()

                    // Find checkboxes and check those; also set indeterminate based on if all inputs are checked or not
                    .find('> div input[type="checkbox"]')
                        .prop('checked', !$(val).parent().find('> div input[type="checkbox"]').attr('disabled'))
                        .prop('indeterminate', $(val).parent().find('> div input[type="checkbox"]').attr('disabled') || inputsLength !== checkedInputsLength)
                        .end()

                    // Find hidden input that gives the checkbox value and set that value based on the indeterminate status
                    .find('> div input[type="hidden"][name*="access"]')
                        .val(inputsLength !== checkedInputsLength ? 'partial' : !$(val).parent().find('> div input[type="checkbox"]').attr('disabled'))
                        .end();
            }
        });
    }

});
